import type React from "react";
import { DayView } from "./DayView/DayView";
import { DaysView } from "./DaysView/DaysView";
import type { SchedulerViewProps } from "./types";

export const calendarViewDay = "day";
export const calendarViewDays = "days";

const calendarViews = {
  [calendarViewDay]: DayView,
  [calendarViewDays]: DaysView,
} satisfies Record<string, React.ComponentType<SchedulerViewProps>>;

export { calendarViews };
